const linkStyle = {
    color: "#B8B8B8",
    boxShadow: 24,
    borderRadius: 10,
    p: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "underline"
};

export { linkStyle };